import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare var window: any;
@Injectable({
    providedIn: 'root'
})
export class CommonConfig {
    

    environment: any;
    configs: any;
    baseUrl!: string;

    constructor() {
        this.environment = environment;
        this.configs = {};
    }

    //     return environment.assetsPrefixUrl + '/images/logo.svg';
    // }
    // /* logo in dark mode*/
    // getSiteLogoDarkMode() {
    //     if (this.logoDarkPath) {
    //         return this.logoDarkPath;
    //     }
    //     return environment.assetsPrefixUrl + '/images/logo-light.svg';
    // }
    //     return environment.assetsPrefixUrl + '/images/logo.svg';
        
    logoPath!: string;
    logoDarkPath!: string;
    private dashboardLayout!: string;


    
    getSiteName() {
        return 'Delfi.ai';
    }
    getSiteUrl() {
        return 'https://www.delfi.ai/';
    }

    getBaseUrl(): string {
        if(this.baseUrl)
            return this.baseUrl;
        const currentHost = window.location.hostname;
        if(currentHost == 'localhost' || currentHost == '127.0.0.1'){
            this.baseUrl = this.getFromConfig('baseUrl', 'https://servicecompany.maredigital.it');
        }
        else {
            this.baseUrl = window.location.origin;
        }
        return this.baseUrl;
    }
    /* logo in default | light mode */
    // getSiteLogo() {
    //     if (this.logoPath) {
    //         return this.logoPath;
    //     }
    //     return environment.assetsPrefixUrl + '/images/logo.svg';
    // }
    // /* logo in dark mode*/
    // getSiteLogoDarkMode() {
    //     if (this.logoDarkPath) {
    //         return this.logoDarkPath;
    //     }
    //     return environment.assetsPrefixUrl + '/images/logo-light.svg';
    // }

    getSiteLogo() {
        if (this.logoPath) {
            return this.logoPath;
        }
        return '/images/logo.svg';
    }
    /* logo in dark mode*/
    getSiteLogoDarkMode() {
        if (this.logoDarkPath) {
            return this.logoDarkPath;
        }
        return '/images/logo-light.svg';
    }

    getWorkingTime() {
        const dayStart  = window.workingtime?.dayStart || environment.workingtime?.dayStart || 1;
        const dayEnd = window.workingtime?.dayEnd || environment.workingtime?.dayEnd || 5;
        const hourStart = window.workingtime?.hourStart || environment.workingtime?.hourStart || 9;
        const hourEnd = window.workingtime?.hourEnd || environment.workingtime?.hourEnd || 18;
        return {
            daystart: dayStart,
            dayend: dayEnd,
            hourstart: hourStart,
            hourend: hourEnd
      }
    }

    getDashboardLayout() {
        if(this.dashboardLayout){
            return this.dashboardLayout;
        } else {
            if (environment.dashboardLayout) {
                if (window.dashboardLayout) {
                    this.dashboardLayout = window.dashboardLayout;
                } else {
                    this.dashboardLayout = environment.dashboardLayout;
                }
            }
            return this.dashboardLayout;
        }
    }

    setDashboardLayout(layout?: string) {
        if (layout) {
            this.dashboardLayout = layout;
        }
        else {
            if (environment.dashboardLayout) {
                if (window.dashboardLayout) {
                    this.dashboardLayout = window.dashboardLayout;
                } else {
                    this.dashboardLayout = environment.dashboardLayout;
                }
            }
        }

    }
    getMobileBreakpoint() {
        return 1024;
    }
    setSiteDarkLogo(logodark: string) {
        this.logoDarkPath = logodark;
    }
    setSiteLogo(logo: string) {
        this.logoPath = logo;
    }

    getFromConfig(key: string, deafult?: any): any {
       if(this.configs[key] == undefined) {
        if(window[key] != undefined) {
            this.configs[key] = window[key];
        } else if(this.environment[key] != undefined) {
            this.configs[key] = this.environment[key];
        } else {
            if(deafult != undefined){
                this.configs[key] = deafult;
            } else {
                this.configs[key] = null;
            }
        }
       } 
       return this.configs[key];
    }

}
